/*
 * Copyright (c) 2025. Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in de overeenkomst tussen Ocaro B.V. en Spin in het Web B.V.
 */

/**
 * xls-datatable.ts
 * 05-03-2024 - Jelmer Jellema - Spin in het Web B.V. Apeldoorn NL
 * Component XlsDatatable
 * Selector: xls-datatable
 * Dependencies: datatable2, exceljs, ngx-filesaver
 * <xls-datatable [datatable]="ref-naar-datatable2"></xls-datatable>
 *
 * Levert een button op die de gefilterde rijen van de betreffende datatable in volgorde exporteert naar een excel
 *
 * Andere imputs:
 * creator: string Naam van de creator van de xls
 * filenaam: string Naam van het excel bestand (default: 'export.xlsx')
 * werkblad: string Naam van het werkblad
 * btnclass: string Class definitie van de button (default: btn btn-outline-primary)
 * icon: string Class definitie van de icon (default: fas fa-download)
 */
import {Component, Input} from "@angular/core";
import {SihwDatatable2} from "sihw-ng/datatable2/datatable2.component";
import * as ExcelJS from "exceljs";
import {FileSaverModule, FileSaverService} from "ngx-filesaver";
import { Sihwlogger, Sihwlog } from "sihw-ng/sihwlog/sihwlog";
import {localConfig} from "../localconfig/localconfig";

@Component({
  standalone: true,
  selector: 'xls-datatable',
  templateUrl: './xls-datatable.html',
  styleUrls: ['xls-datatable.scss'],
  imports: [FileSaverModule]
})
export class XlsDatatable  {
  @Input('datatable') datatable: SihwDatatable2;
  @Input('creator') creator: string = 'xls-datatable door Spin in het Web B.V. Apeldoorn';
  @Input('werkblad') werkblad: string = 'Werkblad';
  @Input('filenaam') filenaam: string = 'Export';
  @Input('btnclass') btnclass: string = 'btn btn-outline-primary';
  @Input('icon') icon: string = 'fas fa-download';


  protected log: Sihwlogger;
  constructor( private fileSaver: FileSaverService, conf: localConfig, sihwLog: Sihwlog) {
       this.log = sihwLog.logger(conf.$('SIHW.config.logLevel','warn'));
  }

  async export() {
    //voer de export uit
    if (! this.datatable)
    {
      this.log.error('Geen datatable');
      return;
    }

    let rijen: any[][] = this.datatable.exportdata(true);
    let koppen = rijen.shift();

    const workbook = new ExcelJS.Workbook;
    workbook.creator = this.creator;
    const sheet = workbook.addWorksheet(this.werkblad, {
      views: [{state: 'frozen',ySplit: 1}],
      properties: {defaultColWidth:  30}
    });
    let row = sheet.addRow(koppen);
    row.font = {bold: true};
    row.alignment = {horizontal: 'center'};
    for(let rij of rijen) //de rest
    {
      sheet.addRow(rij);
    }
    const buffer = await workbook.xlsx.writeBuffer();
    this.fileSaver.save(new Blob([buffer]), `${this.filenaam}.xlsx` );
  }
}
